import type { ShipmentListDTO } from '@uturn/api/v1';
import { Badge } from '@uturn/ui-kit';

export function RequirementBadges({
	requirements = [],
}: {
	requirements: ShipmentListDTO['requirements'];
}) {
	return (
		<div className="flex gap-2 flex-wrap">
			{requirements.length > 0 ? (
				requirements
					.filter((requirement) => requirement.length)
					.map((req) => (
						<Badge key={req} variant="outline">
							{req}
						</Badge>
					))
			) : (
				<span>-</span>
			)}
		</div>
	);
}
